// Reexporta la instancia tipada para unificar interceptores y evitar duplicados
import axiosIns from './axios.ts'
export default axiosIns
